'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc filter
 * @name common.filter:number
 * @function
 *
 * @description
 * Formats a number as a number (ie. 1 234 567,12)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("number", function ($numberFormat) {
  return function numberFilter(value, fixedDecimals, optionalZeroAtTheEnd) {
    if (_.isNaN(value)) {
      return "";
    }
    return $numberFormat.number(value, fixedDecimals, optionalZeroAtTheEnd);
  };
});

// TODO : doc
ngModule.filter("currency", function ($numberFormat) {
  return function currencyFilter(value, fixedDecimals, currencySymbol) {
    if (arguments.length === 2 && _.isString(fixedDecimals)) {
      return $numberFormat.number(value) + " " + fixedDecimals;
    } else if (arguments.length === 3) {
      return $numberFormat.number(value, fixedDecimals) + " " + currencySymbol;
    } else {
      return $numberFormat.currency(value, fixedDecimals);
    }
  };
});

/**
 * @ngdoc filter
 * @name common.filter:percentage
 * @function
 *
 * @description
 * Formats a number as a percentage (ie. 75,12 %)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("percentage", function ($numberFormat) {
  return function percentageFilter(value, fixedDecimals) {
    if (_.isNaN(value)) {
      return "";
    }
    return $numberFormat.percentage(value, fixedDecimals);
  };
});

/**
 * @ngdoc filter
 * @name common.filter:bytes
 * @function
 *
 * @description
 * Formats a number as readable bytes / fileSize (ie. 12,46 Mo)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("bytes", function ($numberFormat) {
  return function numberFilter(value, fixedDecimals) {
    return $numberFormat.bytes(value, fixedDecimals);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/number/numberFilters.js
// module id = 2732
// module chunks = 13